import { Navigate, useLocation } from "react-router-dom";
import { Esqueleto } from "@/componentes/Esqueleto";
import { rotaDoCedente } from "@/rotas";
import { abaInicial } from "./pendencias";
import { useCedenteDaRota } from "./useCedenteDaRota";

/*
 * `/cedentes/:id`: abre onde está o que falta, e sem pendência abre em Contas.
 *
 * `replace` de propósito: o caminho sem aba não é um lugar, e o voltar não pode cair
 * nele para ser mandado de novo para a frente. O `state` segue junto: a linha da lista
 * chega por aqui, e sem ele o "« voltar" perderia os filtros.
 *
 * Espera a leitura, porque decidir antes abriria Contas e saltaria de aba. Se ela
 * falhar, `abaInicial` não tem pendência para ler e fica em Contas, com a faixa acima.
 */
export function AbaPadrao() {
  const { id, pessoa, consulta } = useCedenteDaRota();
  const estado: unknown = useLocation().state;

  if (consulta.isPending) return <Esqueleto className="h-14" />;

  return (
    <Navigate to={rotaDoCedente(id, abaInicial(pessoa?.prontidao))} replace state={estado} />
  );
}
